import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useAsync, useAsyncFn } from "../../../hooks/useAsync";
import BasicDialog from "../../base/BasicDialog";
import LoaderWrapper from "../../wrapper/LoaderWrapper";
import { Button, Grid } from "@mui/material";
import useUserService from "../../../services/userService";
import { useForm } from "../../../hooks/useForm";
import { getErrorMsg, isEmptyValue } from "../../../helpers/methods";
import TextFieldFormControl from "../../field/TextFieldFormControl";
import useIcoService from "../../../services/icoService";
import { useSnackbarAlert } from "../../../context/snackbarAlert";



const IcoArchiveDialog = (props) => {
  const { t } = useTranslation();
  const snackbarAlert = useSnackbarAlert();
  const [isSavingData, setIsSavingData] = useState(false);

  const {
    getIcoAgreementGenerateDetails,
    updateIco
  } = useIcoService();

  const updateIcoFn = useAsyncFn(updateIco)

  const {
    formValue,
    setFormValue,
    onChange,
  } = useForm({
    ico: props.icoId,
  })

  const requiredFields = [
    "ico_location"
  ];

  const icoGenerateData = useAsync(
    () => getIcoAgreementGenerateDetails(props.icoId),
    [props.icoId]);

  useEffect(() => {
    if (icoGenerateData.loading) {
      return;
    }
    setFormValue(icoGenerateData.value)

  }, [icoGenerateData.loading]);

  const isValid = formValue
    ? requiredFields.every(
      (fieldName) => !isEmptyValue(formValue[fieldName])
    ) : false;


  const { getUserSelectList } = useUserService();

  const userSelectList = useAsync(
    () => getUserSelectList(props.searchParams));

  const isLoading = userSelectList.loading 

  const onPrepareDataToSave = () => {
    let dataToSend = {};
    dataToSend.ico = formValue
    return dataToSend;
  };

  const onUpdateIco = () => {
    setIsSavingData(true);
    updateIcoFn
      .execute(props.icoId, onPrepareDataToSave())
      .then((res) => {
        snackbarAlert.openSuccessSnackbarAlert(
          t("snackbar_alert.update_request")
        );
        setIsSavingData(false);
        props.onClose()
        props.onDataRefetch()
      })
      .catch((error) => {
        setIsSavingData(false);
        snackbarAlert.openErrorSnackbarAlert(
          getErrorMsg(error.data),
          t("snackbar_alert.occurred_error_during_updating_request")
        );
      });
  };

  return (
    <BasicDialog
      open={props.open}
      onClose={props.onClose}
      titleAlign="center"
      maxWidth="sm"
      title={t("dialog.ico_archive_dialog.archive_agreement")}
    >
      <LoaderWrapper showLoader={isLoading || isSavingData} >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >

          <Grid item xs={12}>
            <TextFieldFormControl
              name="ico_location"
              required
              value={formValue?.ico_location}
              label={t("dialog.ico_archive_dialog.ico_location")}
              onChange={onChange}
            />
          </Grid>
  
          <Grid item xs={12}>
            <Button
              sx={{ marginTop: "20px" }}
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => onUpdateIco()}
              disabled={!isValid}
            >
              {t("dialog.ico_archive_dialog.archive")}
            </Button>
          </Grid>
        </Grid>
      </LoaderWrapper>
    </BasicDialog>
  );
};

IcoArchiveDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,

};

IcoArchiveDialog.defaultProps = {
  open: false
};

export default IcoArchiveDialog;
